import { render } from "./FounderDetails.vue?vue&type=template&id=2eee2789&scoped=true"
const script = {}

import "./FounderDetails.vue?vue&type=style&index=0&id=2eee2789&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2eee2789"

export default script